module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.bundle !== null) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('bundle-form', {
    attrs: {
      "bundle": _vm.bundle
    },
    on: {
      "saved": _vm.reloadBundle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('bundle-products', {
    attrs: {
      "bundle-id": _vm.bundle.id
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566a413a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/bundles/BundleEdit.vue
// module id = 536
// module chunks = 0